<div class="container">
  <img src="../../../assets/Description/pic1.png" alt="villa" class="picture slide-picture" id="villaPic">
  <img src="../../assets/Description/pic2.png" alt="villa" class="picture slide-picture">
  <img src="../../../assets/Description/pic3.png" alt="villa" class="picture slide-picture">
  <div class="content">
    <div class="arrow arrow-up" (click)="previousSection()" *ngIf="currentSection > 0">
      <div class="arrow-container">
        <em class="fa fa-arrow-up"></em>
      </div>
    </div>
    <div class="arrow arrow-down" (click)="nextSection()" *ngIf="currentSection < 2">
      <div class="arrow-container">
        <em class="fa fa-arrow-down"></em>
      </div>
    </div>
    <div class="indicators">
      <div class="circles">
        <span class="indicator" [class.active]="currentSection === 0" (click)="scrollTo(0)"></span>
        <span class="indicator" [class.active]="currentSection === 1" (click)="scrollTo(1)"></span>
        <span class="indicator" [class.active]="currentSection === 2" (click)="scrollTo(2)"></span>
      </div>
    </div>
    <div class="sections" id="sections">
      <div class="section">
        <div class="section-content">
          <div class="title">{{'Situation' | translate}}
            <span class="counter">1/{{sections.length}}</span>
          </div>
          <p (click)="updateText(description1, updateTextTemplate)">
            {{description1.text}}
          </p>
          <div class="footer">
            <div class="wire-btn" [routerLink]="['/availabilities']">
              <span>{{'Voir les disponibilités' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-content">
          <div class="title">{{'Environnement' | translate}}
            <span class="counter">2/{{sections.length}}</span>
          </div>
          <p (click)="updateText(description2, updateTextTemplate)">
            {{description2.text}}
          </p>
          <div class="footer">
            <div class="wire-btn" [routerLink]="['/equipment']">
              <span>{{'Voir les équipements' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-content">
          <div class="title">{{'La villa' | translate}}
            <span class="counter">3/{{sections.length}}</span>
          </div>
          <p (click)="updateText(description3, updateTextTemplate)">
            {{description3.text}}
          </p>
          <div class="footer">
            <div class="wire-btn" [routerLink]="['/prices']">
              <span>{{'Voir les tarifs' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #updateTextTemplate>
  <div class="modal-content">
    <div class="header">
      Update text
      <div class="close" (click)="modalRef.hide()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <textarea rows="25" [(ngModel)]="textModel.text"></textarea>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveTextModel()">Save</button>
      <button class="wire-btn default" (click)="modalRef.hide()">Cancel</button>
    </div>
  </div>
</ng-template>